import { IHttpClient } from '@wix/http-client';

import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';

const { clientTopology } = renderModel.get();

interface ChatbotSession {
  secondsSinceLastActivity: number | null;
}

const FIVE_MINUTES_IN_SECONDS = 60 * 5;

export const getUserChatbotSessionActivityStatus = async (http: IHttpClient): Promise<boolean> => {
  try {
    const response = await http.get<ChatbotSession>(clientTopology.chatbotSessionURL);
    const secondsSinceLastActivity = parseInt(String(response.data.secondsSinceLastActivity), 10);

    return Number.isNaN(secondsSinceLastActivity)
      ? false
      : secondsSinceLastActivity < FIVE_MINUTES_IN_SECONDS;
  } catch (error) {
    logger.error({
      message: 'failed to fetch chatbot session',
      error,
    });
    return false;
  }
};
